import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { MatInput } from '@angular/material/input'
import { CurrencyMaskModule } from 'ng2-currency-mask'
import { NgxMaskDirective } from 'ngx-mask'
import { HubModalComponent } from '../../shared/ui/hub-modal/hub-modal.component'
import { StepSeparatorLineComponent } from '../features/partners-remuneration/components/step-separator-line/step-separator-line.component'
import { TimelineStepComponent } from '../features/partners-remuneration/components/timeline-step/timeline-step.component'
import { VerticalTimelineComponent } from '../features/partners-remuneration/components/vertical-timeline/vertical-timeline.component'
import { AsyncSwitcherComponent } from './components/async-switcher/async-switcher.component'
import { AutoCompleteSelectComponent } from './components/auto-complete-select/auto-complete-select.component'
import { BarraProgressoComponent } from './components/barra-progresso/barra-progresso.component'
import { CollapseComponent } from './components/collapse/collapse.component'
import { DotLoadingComponent } from './components/dot-loading/dot-loading.component'
import { CollapsibleSectionComponent } from './components/forms/collapsible-section/collapsible-section.component'
import { ControlErrorComponent } from './components/forms/control-error/control-error.component'
import { FormHeaderComponent } from './components/forms/form-header/form-header.component'
import { FormSectionComponent } from './components/forms/form-section/form-section.component'
import { CurrencyInputComponent } from './components/forms/inputs/currency-input/currency-input.component'
import { FormInputComponent } from './components/forms/inputs/form-input/form-input.component'
import { FormOptionsInputComponent } from './components/forms/inputs/form-options-input/form-options-input.component'
import { FormSimpleOptionsInputComponent } from './components/forms/inputs/form-simple-options-input/form-simple-options-input.component'
import { SwitcherInputComponent } from './components/forms/inputs/switcher-input/switcher-input.component'
import { HistoryModal } from './components/history-modal/history-modal.component'
import { InformationModal } from './components/information-modal/information-modal.component'
import { InputErrorComponent } from './components/input-error/input-error.component'
import { LoadingComponent } from './components/loading/loading.component'
import { CustomOfferInfoModalComponent } from './components/modals/custom-offer-info-modal/custom-offer-info-modal.component'
import { InfoModalComponent } from './components/modals/info-modal/info-modal.component'
import { MembershipOfferInfoModalComponent } from './components/modals/membership-offer-info-modal/membership-offer-info-modal.component'
import { MinimumPricingInfoModalComponent } from './components/modals/minimum-pricing-info-modal/minimum-pricing-info-modal.component'
import { OfferConfirmationModalComponent } from './components/modals/offer-confirmation-modal/offer-confirmation-modalcomponent'
import { PricingPlansTerminalValueModalComponent } from './components/modals/pricing-plans-terminal-value-modal/pricing-plans-terminal-value-modal.component'
import { RejectModalComponent } from './components/modals/reject-modal/reject-modal.component'
import { ModuleSwitcherComponent } from './components/module-switcher/module-switcher.component'
import { MultiSelectDropdownComponent } from './components/multi-select-dropdown/multi-select-dropdown.component'
import { PaginationComponent } from './components/pagination/pagination.component'
import { ProposalPdfComponent } from './components/proposal-pdf/proposal-pdf.component'
import { RetryComponent } from './components/retry/retry.component'
import { SearchBarComponent } from './components/search/search-bar/search-bar.component'
import { SearchOptionsComponent } from './components/search/search-options/search-options.component'
import { SearchableSelectComponent } from './components/search/searchable-select/searchable-select.component'
import { SelectLiveSearchComponent } from './components/select-live-search/select-live-search.component'
import { SimpleModal } from './components/simple-modal/simple-modal.component'
import { RadialStepperComponent } from './components/stepper-indicators/radial-stepper/radial-stepper.component'
import { StepperComponent } from './components/stepper-indicators/stepper/stepper.component'
import { TabsComponent } from './components/tabs/tabs.component'
import { StatusTagComponent } from './components/tags/status-tag/status-tag.component'
import { Warning } from './components/warning/warning.component'
import { CNPJPipe } from './pipes/cnpj.pipe'
import { CPFPipe } from './pipes/cpf.pipe'
import { HideTextPipe } from './pipes/hide-text.pipe'
import { LocaleDatePipe } from './pipes/locale-date.pipe'
import { SafeHtmlPipe } from './pipes/safehtml.pipe'
import { LiveSearchFilterPipe } from './pipes/search-filter.pipe'
import { ProposalMdrTableComponent } from './proposal-mdr-table/proposal-mdr-table.component'

@NgModule({
    declarations: [
        DotLoadingComponent,
        InfoModalComponent,
        CollapsibleSectionComponent,
        ControlErrorComponent,
        FormHeaderComponent,
        FormSectionComponent,
        CurrencyInputComponent,
        FormInputComponent,
        FormSimpleOptionsInputComponent,
        FormOptionsInputComponent,
        SwitcherInputComponent,
        SelectLiveSearchComponent,
        MultiSelectDropdownComponent,
        AsyncSwitcherComponent,
        CollapseComponent,
        CustomOfferInfoModalComponent,
        MembershipOfferInfoModalComponent,
        MinimumPricingInfoModalComponent,
        OfferConfirmationModalComponent,
        PricingPlansTerminalValueModalComponent,
        RejectModalComponent,
        ProposalPdfComponent,
        SearchBarComponent,
        SearchOptionsComponent,
        SearchableSelectComponent,
        TabsComponent,
        StatusTagComponent,
        Warning,
        CNPJPipe,
        CPFPipe,
        HideTextPipe,
        LocaleDatePipe,
        SafeHtmlPipe,
        LiveSearchFilterPipe,
        PaginationComponent,
        InformationModal,
        SimpleModal,
        InputErrorComponent,
        AutoCompleteSelectComponent,
        LoadingComponent,
        BarraProgressoComponent,
        RadialStepperComponent,
        StepperComponent,
        HistoryModal,
        ProposalMdrTableComponent,
        VerticalTimelineComponent,
        StepSeparatorLineComponent,
        TimelineStepComponent,
        ModuleSwitcherComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        CurrencyMaskModule,
        NgxMaskDirective,
        MatAutocompleteModule,
        ReactiveFormsModule,
        MatInput,
        HubModalComponent,
        HubModalComponent,
        RetryComponent,
    ],
    exports: [
        DotLoadingComponent,
        InfoModalComponent,
        CollapsibleSectionComponent,
        ControlErrorComponent,
        FormHeaderComponent,
        FormSectionComponent,
        CurrencyInputComponent,
        FormInputComponent,
        FormSimpleOptionsInputComponent,
        FormOptionsInputComponent,
        SwitcherInputComponent,
        SelectLiveSearchComponent,
        MultiSelectDropdownComponent,
        AsyncSwitcherComponent,
        CollapseComponent,
        CustomOfferInfoModalComponent,
        MembershipOfferInfoModalComponent,
        MinimumPricingInfoModalComponent,
        OfferConfirmationModalComponent,
        PricingPlansTerminalValueModalComponent,
        RejectModalComponent,
        ProposalPdfComponent,
        RetryComponent,
        SearchBarComponent,
        SearchOptionsComponent,
        SearchableSelectComponent,
        TabsComponent,
        StatusTagComponent,
        Warning,
        CNPJPipe,
        CPFPipe,
        HideTextPipe,
        LocaleDatePipe,
        SafeHtmlPipe,
        LiveSearchFilterPipe,
        PaginationComponent,
        InformationModal,
        InputErrorComponent,
        AutoCompleteSelectComponent,
        LoadingComponent,
        BarraProgressoComponent,
        RadialStepperComponent,
        StepperComponent,
        HistoryModal,
        VerticalTimelineComponent,
        StepSeparatorLineComponent,
        TimelineStepComponent,
        HubModalComponent,
        ModuleSwitcherComponent,
    ],
})
export class SharedModule {}
